var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
var AnalyticsProvider = /** @class */ (function () {
    function AnalyticsProvider(platform, comProv) {
        this.platform = platform;
        this.comProv = comProv;
    }
    /*startTrackerWithId(id) {
      try {
        ga('create', {
          storage: 'none',    ​
          trackingId: id,    ​
          clientId: localStorage.getItem('ga:clientId')
        });    ​
        ga('set', 'checkProtocolTask', null);​
        ga('set', 'transportUrl', 'https://www.google-analytics.com/collect');
        ga(function(tracker) {
          if (!localStorage.getItem('ga:clientId')) {
            localStorage.setItem('ga:clientId', tracker.get('clientId'));
          }
        });
      } catch(e) {
        console.log(e);
      }
    }*/
    /*trackView(screenName) {
      let page_name = this.getPageName(screenName);
      try {
        ga('set', 'page', page_name);
        ga('send', 'pageview');
      } catch(e) {
        console.log(e);
      }
    }*/
    AnalyticsProvider.prototype.trackViewGA4 = function (screenName) {
        var page_name = this.getPageName(screenName);
        try {
            // GA4
            gtag('event', 'page_view', {
                'page_title': page_name,
            });
        }
        catch (e) {
            console.log(e);
        }
    };
    /*trackEvent(category, action=null, label=null, value=null) {
      if (!action) {
        action = 'no title';
      }
      let action_name = this.getPageName(action);
      try {
        ga('send', 'event', {
          eventCategory: category,
          eventAction: action_name,
          eventLabel: label,
          eventValue: value
        });
      } catch(e) {
        console.log(e);
      }
    }*/
    AnalyticsProvider.prototype.trackDetail = function (event, detail_title) {
        if (detail_title === void 0) { detail_title = null; }
        var service_data = this.comProv.getService();
        if (!service_data['ga4_tracking_id']) {
            return;
        }
        if (!detail_title) {
            detail_title = 'no title';
        }
        try {
            gtag('event', event, {
                'page_title': detail_title,
            });
        }
        catch (e) {
            console.log(e);
        }
    };
    AnalyticsProvider.prototype.trackClick = function (event, target, url) {
        if (url === void 0) { url = null; }
        var service_data = this.comProv.getService();
        if (!service_data['ga4_tracking_id']) {
            return;
        }
        var page_name = this.getPageName(target);
        try {
            if (url) {
                gtag('event', event, {
                    'page_title': page_name,
                    'page_location': url,
                });
            }
            else {
                gtag('event', event, {
                    'page_title': page_name,
                });
            }
        }
        catch (e) {
            console.log(e);
        }
    };
    AnalyticsProvider.prototype.getPageName = function (page) {
        var page_name = page;
        switch (page) {
            case 'HomePage':
            case 'home':
                page_name = 'ホーム';
                break;
            case 'ShopIndexPage':
                page_name = 'ショップ';
                break;
            case 'ShopDetailPage':
                page_name = 'ショップ詳細';
                break;
            case 'CouponIndexPage':
                page_name = 'クーポン';
                break;
            case 'EventIndexPage':
                page_name = 'イベント';
                break;
            case 'EventDetailPage':
                page_name = 'イベント詳細';
                break;
            case 'StampIndexPage':
                page_name = 'スタンプ';
                break;
            case 'StampBarcodePage':
                page_name = 'スタンプ バーコード';
                break;
            case 'PushIndexPage':
                page_name = 'お知らせ';
                break;
            case 'PushDetailPage':
                page_name = 'お知らせ詳細';
                break;
            case 'MenuIndexPage':
                page_name = 'メニュー';
                break;
            case 'MenuDetailPage':
                page_name = 'メニュー詳細';
                break;
            case 'PhotoIndexPage':
                page_name = 'フォト';
                break;
            case 'PhotoDetailPage':
                page_name = 'フォト詳細';
                break;
            //case 'FreeIndexPage':
            //  page_name = 'フリーページ';
            //  break;
            case 'MovieIndexPage':
                page_name = 'ムービー';
                break;
            case 'ShareIndexPage':
                page_name = '紹介';
                break;
            case 'MemberIndexPage':
                page_name = '会員証';
                break;
            case 'MemberBarcodePage':
                page_name = '会員証バーコード';
                break;
            case 'MemberFormPage':
                page_name = '会員証フォーム';
                break;
            case 'ScoreIndexPage':
                page_name = 'スコア';
                break;
            case 'ScoreDetailPage':
                page_name = 'スコアガイド';
                break;
            case 'ScoreRankPage':
                page_name = 'スコア特典';
                break;
            case 'ScoreHistoryPage':
                page_name = 'スコア履歴';
                break;
            case 'InfoIndexPage':
                page_name = '設定';
                break;
            case 'InfoProfilePage':
                page_name = 'プロフィール設定';
                break;
            case 'InfoEmailPage':
                page_name = 'メールアドレス変更';
                break;
            case 'InfoPasswordPage':
                page_name = 'パスワード変更';
                break;
            case 'InfoPinPage':
                page_name = '引継ぎコード設定';
                break;
            case 'InfoInheritPage':
                page_name = 'データ引継ぎ';
                break;
            case 'InfoRulePage':
                page_name = '利用規約';
                break;
            case 'InfoPrivacyPage':
                page_name = 'プライバシーポリシー';
                break;
            case 'ReaderIndexPage':
                page_name = 'バーコードリーダー';
                break;
            case 'ReserveIndexPage':
                page_name = '予約';
                break;
            case 'TopPage':
                page_name = '初回トップ';
                break;
            case 'TopShopPage':
                page_name = '初回お気にり登録';
                break;
            case 'TopProfilePage':
                page_name = '初回プロフィール登録';
                break;
            case 'LoginPage':
                page_name = 'ログイン';
                break;
            case 'LoginPasswordPage':
                page_name = 'パスワードリセット';
                break;
            case 'SharePage':
                page_name = '紹介';
                break;
            case 'PrivacyPage':
                page_name = 'プライバシーポリシー';
                break;
        }
        if (page.indexOf('FreeIndexPage') === 0) {
            page_name = 'フリーページ';
        }
        else if (page.indexOf('CategoryMenuIndexPage') === 0) {
            page_name = 'フリーメニュー';
        }
        return page_name;
    };
    AnalyticsProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [Platform,
            CommonProvider])
    ], AnalyticsProvider);
    return AnalyticsProvider;
}());
export { AnalyticsProvider };
//# sourceMappingURL=analytics.js.map


// WEBPACK FOOTER //
// ./src/providers/analytics/analytics.ts.pre-build-optimizer.js